export const LOADING = 'loading';
export const SUCCEED = 'succeed';
export const FAILURE = 'failure';

export default {
  LOADING,
  SUCCEED,
  FAILURE
};
